import { createReactComponent, IconNode } from "@tabler/icons-react"

const iconNode: IconNode = [
  ["path", { d: "M8 21h-2a3 3 0 0 1 -3 -3v-1h5.5", key: "path-1" }],
  ["path", { d: "M17 8.5v-3.5a2 2 0 1 1 2 2h-2", key: "path-2" }],
  ["path", { d: "M19 3h-11a3 3 0 0 0 -3 3v11", key: "path-3" }],
  ["path", { d: "M9 7h4", key: "path-4" }],
  ["path", { d: "M9 11h4", key: "path-5" }],
  ["path", { d: "m 14.930591,18.18509 2,2 4,-4", key: "path-6" }],
]

export const IconContractCheck = createReactComponent(
  "outline",
  "contract-check",
  "IconContractCheck",
  iconNode
)
